import React, { useEffect, useState } from "react";
import { adminClient } from "../../../lib/admin";
import { Users, Star, MessageSquare, Package, Award } from "lucide-react";

const CARDS = [
  { key: "users", label: "Total Users", icon: Users },
  { key: "customers", label: "Customers", icon: Users },
  { key: "reviews_pending", label: "Reviews Pending", icon: Star },
  { key: "tickets_open", label: "Open Tickets", icon: MessageSquare },
  { key: "orders_cached", label: "Orders Synced", icon: Package },
  { key: "certificates", label: "Certificates", icon: Award },
];

export default function AdminOverview() {
  const [counts, setCounts] = useState({});
  useEffect(() => { adminClient().get("/admin/overview").then(({ data }) => setCounts(data.counts)).catch(() => {}); }, []);
  return (
    <div data-testid="admin-overview">
      <h2 className="text-xl font-black font-display mb-5">Dashboard Overview</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {CARDS.map((c) => (
          <div key={c.key} className="bg-white border border-black/10 p-5">
            <c.icon className="w-5 h-5 text-taven-gold" />
            <p className="text-3xl font-black mt-2" data-testid={`overview-${c.key}`}>{counts[c.key] ?? "—"}</p>
            <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{c.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
